module.exports = __webpack_public_path__ + "static/media/louis1.8458c952.mp3";